export type CheckboxOption = {
  label: string
  name: string
  optionKey: string | number | boolean
  checked?: boolean
  autofocus?: boolean
  disabled?: boolean
}

export type CheckboxEventDetail = {
  name: string
  optionKey: string | number | boolean
  checked: boolean
}
